const ACCOUNT = 'coast-riders';
const FOLDER = 'enduro-perun';

export function getCloudinaryUrl(image) {
  return `https://res.cloudinary.com/${ACCOUNT}/image/upload/${FOLDER}/${image}`;
}
